import type { Link, Resource } from '@readium/shared';
import { HttpFetcher, type FetchImplementation } from '@readium/shared';
import { type ChapterTransform, CustomHttpResource } from './CustomHttpResource';

export class CustomHttpFetcher extends HttpFetcher {
  private readonly cipherKey?: string;
  private readonly transformChapter?: ChapterTransform;

  constructor(
    client?: FetchImplementation,
    baseUrl?: string,
    options: { cipherKey?: string; transformChapter?: ChapterTransform } = {},
  ) {
    super(client, baseUrl);
    this.cipherKey = options.cipherKey;
    this.transformChapter = options.transformChapter;
  }

  override get(link: Link): Resource {
    const resource: Resource = new CustomHttpResource(
      super.get(link),
      this.cipherKey,
      this.transformChapter,
    );

    return resource;
  }
}
